export enum InvestigationQuestionType {
	Base = 1,
	Negating = 2,
	Confrontation = 3,
	Clarification = 4,
}
